{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           PrjClassHBMDataAccess
    Folder:             ../..
    Created:            Tue 06.06.2023 13:14
    Author:             Michael Ellermann

    ShortDescription:   Die Klasse ermöglicht den Zugriff auf die Array und Record Strukturen


    Description:        Zugriff auf die "alten" Datenstrukturen, wird für jeden User Instanziert
                        kapselt alle Zugriffe in einer Klasse

**                                                                                                **
****************************************************************************************************
MnemoREM}

unit PrjClassHBMDataAccess;

interface

uses
  System.SysUtils,
  System.Classes,
  System.Rtti,
  System.TypInfo,
  System.StrUtils,
  System.Types,
  System.Generics.Collections,
  System.Generics.Defaults,

  JS,
  Web,
  WEBLib.Modules,
  WEBLib.REST,
  WEBLib.Controls,
  WebLib.ExtCtrls,
  Data.DB,
  XData.Web.Connection,
//  XData.Web.JsonDataset,
  XData.Web.Dataset,
  XData.Web.Client,


  wxBaseClassWebTools,
  PrjClassTokenInformation,
  PrjClassHelperClasses,
  PrjClassHBMDefaultData;

const
  cJWTSecret = 'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY4ODY2NjQzNywiaWF0IjoxNjg4NjY2NDM3fQ.EMUc-VWJcTi75-zr83RE6OxdOhHGdD6C8ahqnTdje-c';


type
  TPermissionItem = class(TPersistent)
  private
    FPermissionDelete: Boolean;
    FPermissionIndex: Integer;
    FPermissionRead: Boolean;
    FPermissionWrite: Boolean;
  published
    property PermissionDelete: Boolean read FPermissionDelete write FPermissionDelete;
    property PermissionIndex: Integer read FPermissionIndex write FPermissionIndex;
    property PermissionRead: Boolean read FPermissionRead write FPermissionRead;
    property PermissionWrite: Boolean read FPermissionWrite write FPermissionWrite;
  end;

type
  TPrjClassHBMDataAccess = class(TObject)
  strict private

    [Async]
    procedure WebTimerTimer(Sender: TObject); async;
  private
    FWebRequest: THttpRequest;
    FAktSimulationParaStr_ : string;
    FAktuelleSimulation: Integer;
    FDataConnection: TXDataWebConnection;
    FisAdministrator: Boolean;
    FisSpielleiter: Boolean;
    FPermissionItems : TObjectList<TPermissionItem>;
    FWebTimer : TTimer;
    FXDataWebClient: TXDataWebClient;
    FOwner: TComponent;
    FWebDataSet: TXDataWebDataSet;
    function GetAktuelleSimulation: Integer;
    function GetisAdministrator: Boolean;
    function GetToken: string;
    function GetWebDataSet: TXDataWebDataSet;
    function GetWebRequest: THttpRequest;
    procedure SetAktuelleSimulation(const Value: Integer);
    procedure SetWebRequest(const Value: THttpRequest);
    procedure WebDataSetAfterOpen(DataSet: TDataSet);
    procedure WebRequestAbort(Sender: TObject);
    procedure WebRequestError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
    procedure WebRequestTimeout(Sender: TObject);
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
    [async]
    function InitializeSession: Boolean; async; virtual;
    [async]
    function RequestDaten(ADataTyp: Char; AXDataConnection: TXDataWebConnection; const ASubFunction: string = ''): Boolean; async; virtual;
    [async]
    function RequestDBDaten(ADataSet: TXDataWebDataSet; AXDataConnection: TXDataWebConnection): Boolean; async; virtual;
    [async]
    function RequestLockInformation: Boolean; async; virtual;
    [async]
    function ReloadSession(ADataConnection: TXDataWebConnection): Boolean; async;
    [async]
    function RequestAuthentication(ADataTyp: Char; AXDataConnection: TXDataWebConnection): string; async;

    function XDataWebClient(AXDataConnection: TXDataWebConnection): TXDataWebClient; virtual;
  published
    property AktuelleSimulation: Integer read GetAktuelleSimulation write SetAktuelleSimulation;
    property DataConnection: TXDataWebConnection read FDataConnection write FDataConnection;
    property isAdministrator: Boolean read GetisAdministrator write FisAdministrator default false;
    property isSpielleiter: Boolean read FisSpielleiter write FisSpielleiter default false;
    property WebDataSet: TXDataWebDataSet read GetWebDataSet write FWebDataSet;
    property WebRequest: THttpRequest read GetWebRequest write SetWebRequest;

  end;

var
  Abteilungen         : TTablePropertiesObjectList;
  drgFaelle           : TTablePropertiesObjectList;
  Institute           : TTablePropertiesObjectList;
  Stationen           : TTablePropertiesObjectList;
  SoftSkills          : TTablePropertiesObjectList;


implementation

uses
  weblib.WebTools,
  HBMWebData,

  {$IFDEF APPISSPL}
  PrjFormMain,
  {$ENDIF}

  HBMWebDef;


procedure TPrjClassHBMDataAccess.WebDataSetAfterOpen(DataSet: TDataSet);
var LTableProps : TTableProperties;
var i : integer;
begin

  if (DataSet as TXDataWebDataSet).EntitySetName = 'Tblhbm_Abteilungen' then
  begin
    while not DataSet.Eof do
    begin
      LTableProps             := TTableProperties.Create;
      LTableProps.FAssignment := DataSet.FieldByName('MABT_ASSIGNMENT').AsInteger;
      LTableProps.FPeriod     := DataSet.FieldByName('MABT_VALID_PERIOD').AsInteger;
      LTableProps.FContent    := DataSet.FieldByName('Mabt_Department_Name').AsString;
      Abteilungen.Add(LTableProps);
      DataSet.Next;
    end;
    Abteilungen.Sort;
  end;

  if (DataSet as TXDataWebDataSet).EntitySetName = 'Tblhbm_Stationen' then
  begin
    while not DataSet.Eof do
    begin
      LTableProps             := TTableProperties.Create;
      LTableProps.FAssignment := DataSet.FieldByName('MAST_ASSIGNMENT').AsInteger;
      LTableProps.FPeriod     := DataSet.FieldByName('MAST_VALID_PERIOD').AsInteger;
      LTableProps.FContent    := DataSet.FieldByName('MAST_STATION').AsString;
      Stationen.Add(LTableProps);
      DataSet.Next;
    end;
    Stationen.Sort;
  end;

  if (DataSet as TXDataWebDataSet).EntitySetName = 'Tblhbm_Institute' then
  begin
    while not DataSet.Eof do
    begin
      LTableProps             := TTableProperties.Create;
      LTableProps.FAssignment := DataSet.FieldByName('MAIT_ASSIGNMENT').AsInteger;
      LTableProps.FPeriod     := DataSet.FieldByName('MAIT_VALID_PERIOD').AsInteger;
      LTableProps.FContent    := DataSet.FieldByName('MAIT_INSTITUT').AsString;
      Institute.Add(LTableProps);
      DataSet.Next;
    end;
    Institute.Sort;
  end;

  if (DataSet as TXDataWebDataSet).EntitySetName = 'Tblhbm_Faelle' then
  begin
    while not DataSet.Eof do
    begin
      LTableProps                     := TTableProperties.Create;
      LTableProps.FAssignment         := DataSet.FieldByName('MAFA_ASSIGNMENT').AsInteger;
      LTableProps.FPeriod             := DataSet.FieldByName('MAFA_VALID_PERIOD').AsInteger;
      LTableProps.FContent            := DataSet.FieldByName('Mafa_Fallname').AsString;
      LTableProps.FOptionalIntField1  := DataSet.FieldByName('MAFA_DEPARTMENT_ID').AsInteger;
      LTableProps.FPrevAssignment     := DataSet.FieldByName('MAFA_PREVIOUS_ASSIGNMENT').AsInteger;
      LTableProps.FSortOrder          := DataSet.FieldByName('MAFA_ORDER_BY').AsInteger;
      drgFaelle.Add(LTableProps);
      DataSet.Next;
    end;
    drgFaelle.Sort;
  end;

  if (DataSet as TXDataWebDataSet).EntitySetName = 'Tblhbm_Softskills' then
  begin
    while not DataSet.Eof do
    begin
      LTableProps             := TTableProperties.Create;
      LTableProps.FAssignment := DataSet.FieldByName('MASK_ASSIGNMENT').AsInteger;
      LTableProps.FPeriod     := DataSet.FieldByName('MASK_VALID_PERIOD').AsInteger;
      LTableProps.FContent    := DataSet.FieldByName('MASK_SOFTSKILL').AsString;
      SoftSkills.Add(LTableProps);
      DataSet.Next;
    end;
    SoftSkills.Sort;
  end;
end;

constructor TPrjClassHBMDataAccess.Create(AOwner: TComponent);
begin
  inherited;

  if Assigned(AOwner) then
  begin
    FOwner := AOwner;
  end;

  if not Assigned(FWebTimer) then
  begin
    FWebTimer           := TTimer.Create(AOwner);
    FWebTimer.Enabled   := false;
    FWebTimer.Interval  := cLockCheckInterval;
    FWebTimer.OnTimer   := WebTimerTimer;
  end;
end;

destructor TPrjClassHBMDataAccess.Destroy;
begin
  if Assigned(FWebTimer) then
  begin
    FreeAndNil(FWebTimer);
  end;

  if Assigned(Abteilungen) then
  begin
    FreeAndNil(Abteilungen);
  end;

  if Assigned(Stationen) then
  begin
    FreeAndNil(Stationen);
  end;

  if Assigned(Institute) then
  begin
    FreeAndNil(Institute);
  end;

  if Assigned(drgFaelle) then
  begin
    FreeAndNil(drgFaelle);
  end;

  if Assigned(SoftSkills) then
  begin
    FreeAndNil(SoftSkills);
  end;

  inherited;
end;

function TPrjClassHBMDataAccess.RequestDaten(ADataTyp: Char; AXDataConnection: TXDataWebConnection; const ASubFunction: string = ''): Boolean;
var LIdx       : integer;
var LResponse  : TXDataClientResponse;
var LJsText    : string;
var LPayLoad   : TStringList;
var LToken     : string;
begin
  Result    := true;
  LPayLoad  := TStringList.Create;
  LToken    := DataModule.TokenInformation.OriginalToken;

  try
    try
      LPayLoad.Add(DataModule.HBMDefaultData.CalculatedPeriod.ToString);
      LPayLoad.Add(DataModule.HBMDefaultData.CalculatedEnterprise.ToString);
      LPayLoad.Add(DataModule.HBMDefaultData.CalculatedDepartment.ToString);
      LPayLoad.Add(DataModule.HBMDefaultData.CalculatedCase.ToString);
      LJsText := LPayLoad.CommaText;

//      console.log(LJsText);

      if Assigned(AXDataConnection) and (AXDataConnection.Connected) then
      begin
        try
          LResponse := Await(Self.XDataWebClient(AXDataConnection).RawInvokeAsync('IDataServices.RequestDaten', [ AktuelleSimulation,
                                                                                                                  DataModule.TokenInformation.UserName,
                                                                                                                  ADataTyp,
                                                                                                                  LJsText,
                                                                                                                  ASubFunction,
                                                                                                                  LToken
                                                                                                                ]));

          LJsText := LResponse.ResponseText;
          case ADataTyp of
            'N' : begin
                    if pos('OK', LJsText) > 0 then
                    begin
                      wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: actual period [' + DataModule.HBMDefaultData.AktuellePeriode.ToString + '] is calculated', slDebug);
                    end;
                  end;
            'I' : begin
                    if ASubFunction = 'PP' then
                    begin
                      if pos('OK', LJsText) > 0 then
                      begin
                        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: insert performance planning data [' + DataModule.HBMDefaultData.AktuellePeriode.ToString + '] was successfull', slDebug);
                      end;
                    end;
                  end;
            'R' : begin
                    if pos('OK', LJsText) > 0 then
                    begin
                      wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: reset simulation successful', slDebug);
                    end;
                  end;
            'U' : begin
                    if ASubFunction = 'PP' then
                    begin
                      if pos('OK', LJsText) > 0 then
                      begin
                        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: updating performance planning data [' + DataModule.HBMDefaultData.AktuellePeriode.ToString + '] was successfull', slDebug);
                      end;
                    end;
                  end;
            'X' : begin
                    if pos('OK', LJsText) > 0 then
                    begin
                      wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: reset TLN passwords successful', slDebug);
                    end;
                  end;
            'Z' : begin
                    if pos('OK', LJsText) > 0 then
                    begin
                      wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten: transfer Seminar Kenndaten successful', slDebug);
                    end;
                  end;
          end;
        except
          on Error: Exception do
          begin
            wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten -> something went wrong...' + Error.Message, slDebug);
            result := false;
          end;
        end;
      end else
      begin
        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten -> not connected...', slDebug);
        result := false;
      end;
    finally
      FreeAndNil(LPayLoad);
    end;
  except
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess: RequestDaten: Es ist ein Fehler aufgetreten', slError);
    result := false;
  end;
end;


function TPrjClassHBMDataAccess.RequestAuthentication(ADataTyp: Char; AXDataConnection: TXDataWebConnection): string;
var LIdx       : integer;
var LResponse  : TXDataClientResponse;
var LToken     : string;
begin
  Result    := '';
  try
    try
      if Assigned(AXDataConnection) and (AXDataConnection.Connected) then
      begin
        try
          case ADataTyp of
            'T' : begin
                    LResponse := Await(Self.XDataWebClient(AXDataConnection).RawInvokeAsync('IAuthServices.ReNewToken', [AktuelleSimulation, DataModule.TokenInformation.UserID]));
                    LToken := LResponse.ResponseText;

                    if LToken <> '' then
                      Result := LToken
                    else
                      Result := 'NOK';
                  end;
          end;
        except
          on Error: Exception do
          begin
            wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestAuthentication -> something went wrong...' + Error.Message, slDebug);
            result := 'NOK';
          end;
        end;
      end else
      begin
        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestDaten -> not connected...', slDebug);
        result := 'NOK';
      end;
    finally
    end;
  except
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess: RequestDaten: Es ist ein Fehler aufgetreten', slError);
    result := 'NOK';
  end;
end;



function TPrjClassHBMDataAccess.GetWebRequest: THttpRequest;
begin
  if not assigned(FWebRequest) then
  begin
    Self.FWebRequest                        := THttpRequest.Create(FOwner);

    Self.FWebRequest.Headers.Duplicates     := System.Types.dupIgnore;
    Self.FWebRequest.Headers.Sorted         := true;
    Self.FWebRequest.Headers.CaseSensitive  := false;


    Self.FWebRequest.OnAbort      := WebRequestAbort;
    Self.FWebRequest.OnError      := WebRequestError;
    Self.FWebRequest.OnTimeOut    := WebRequestTimeout;
    Self.FWebRequest.Command      := httpGET;
    Self.FWebRequest.ResponseType := rtDefault;
    Self.FWebRequest.Headers.Add('Accept=application/json');

  end;
  Result := FWebRequest;
end;

procedure TPrjClassHBMDataAccess.SetWebRequest(const Value: THttpRequest);
begin
  FWebRequest := Value;
end;

procedure TPrjClassHBMDataAccess.SetAktuelleSimulation(const Value: Integer);
begin
  FAktuelleSimulation   := Value;
end;

function TPrjClassHBMDataAccess.GetAktuelleSimulation: Integer;
var LSimulationQueryStr : string;
begin
  LSimulationQueryStr := '';
  if not HasQueryParam ('SIM', LSimulationQueryStr, false) then
  begin
    HasQueryParam ('sim', LSimulationQueryStr, false);
  end;

  if LSimulationQueryStr <> '' then
  begin
    LSimulationQueryStr := UpperCase(LSimulationQueryStr);

    if LSimulationQueryStr.Contains('SIM') then
    begin
      LSimulationQueryStr := Copy(LSimulationQueryStr, 4, Length(LSimulationQueryStr));
    end;

    if not TryStrToInt(LSimulationQueryStr, FAktuelleSimulation) then
    begin
      wxBaseWriteLog.Write('TPrjClassHBMDataAccess.GetAktuelleSimulation : SIM passed ' + LSimulationQueryStr, slDebug);
      FAktuelleSimulation := 999;
    end;
  end else
  begin
    FAktuelleSimulation := 1;
  end;
  Result := FAktuelleSimulation;
end;

function TPrjClassHBMDataAccess.GetisAdministrator: Boolean;
var LAdminQueryStr : string;
begin
  LAdminQueryStr := '';
  if not HasQueryParam ('ADMIN', LAdminQueryStr) then
  begin
    HasQueryParam ('admin', LAdminQueryStr);
  end else
  begin
  end;

  if LAdminQueryStr <> '' then
  begin
    FisAdministrator := UpperCase(LAdminQueryStr) = 'ADMIN';
  end else
  begin
    FisAdministrator := false;
  end;

  Result := FisAdministrator;
end;

function TPrjClassHBMDataAccess.GetToken: string;
begin
  if not JS.IsNull(window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName)) then
  begin
    Result := window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName);
  end else
    Result := '';
end;

function TPrjClassHBMDataAccess.GetWebDataSet: TXDataWebDataSet;
begin
  if Assigned(DataConnection) then
  begin
    if not Assigned(FWebDataSet) then
    begin
      FWebDataSet             := TXDataWebDataSet.Create(nil);
      FWebDataSet.AfterOpen   := WebDataSetAfterOpen;
      FWebDataSet.Connection  := DataConnection;
    end;
  end;
  Result := FWebDataSet;
end;

function TPrjClassHBMDataAccess.InitializeSession: Boolean;
var LIdx                : integer;
var LDataSetAbteilungen : TXDataWebDataSet;
var LDataSetStationen   : TXDataWebDataSet;
var LDataSetInstitue    : TXDataWebDataSet;
var LDataSetFaelle      : TXDataWebDataSet;
var LDataSetSoftSkills  : TXDataWebDataSet;
var LQuery              : TXDataWebDataSet;

begin
  result := false;
  try
    if not Assigned(Abteilungen) then
      Abteilungen := TTablePropertiesObjectList.Create
    else
      Abteilungen.Clear;

    if not Assigned(drgFaelle) then
      drgFaelle   := TTablePropertiesObjectList.Create
    else
      drgFaelle.Clear;

    if not Assigned(Institute) then
      Institute   := TTablePropertiesObjectList.Create
    else
      Institute.Clear;

    if not Assigned(Stationen) then
      Stationen   := TTablePropertiesObjectList.Create
    else
      Stationen.Clear;

    if not Assigned(SoftSkills) then
      SoftSkills  := TTablePropertiesObjectList.Create
    else
      SoftSkills.Clear;

    try
      if Assigned(DataConnection) then
      begin
        LDataSetAbteilungen             := TXDataWebDataSet.Create(nil);
        LDataSetAbteilungen.Connection  := DataConnection;
        LDataSetAbteilungen.AfterOpen   := WebDataSetAfterOpen;
      end;
      await(LDataSetAbteilungen.Close);
      LDataSetAbteilungen.EntitySetName := 'Tblhbm_Abteilungen';
      await(LDataSetAbteilungen.Load);

      if Assigned(DataConnection) then
      begin
        LDataSetStationen             := TXDataWebDataSet.Create(nil);
        LDataSetStationen.AfterOpen   := WebDataSetAfterOpen;
        LDataSetStationen.Connection  := DataConnection;
      end;
      await(LDataSetStationen.Close);
      LDataSetStationen.EntitySetName := 'Tblhbm_Stationen';
      await(LDataSetStationen.Load);


      if Assigned(DataConnection) then
      begin
        LDataSetInstitue             := TXDataWebDataSet.Create(nil);
        LDataSetInstitue.AfterOpen   := WebDataSetAfterOpen;
        LDataSetInstitue.Connection  := DataConnection;
      end;
      await(LDataSetInstitue.Close);
      LDataSetInstitue.EntitySetName := 'Tblhbm_Institute';
      await(LDataSetInstitue.Load);


      if Assigned(DataConnection) then
      begin
        LDataSetFaelle             := TXDataWebDataSet.Create(nil);
        LDataSetFaelle.AfterOpen   := WebDataSetAfterOpen;
        LDataSetFaelle.Connection  := DataConnection;
      end;
      await(LDataSetFaelle.Close);
      LDataSetFaelle.EntitySetName := 'Tblhbm_Faelle';
      await(LDataSetFaelle.Load);

      if Assigned(DataConnection) then
      begin
        LDataSetSoftSkills             := TXDataWebDataSet.Create(nil);
        LDataSetSoftSkills.AfterOpen   := WebDataSetAfterOpen;
        LDataSetSoftSkills.Connection  := DataConnection;
      end;
      await(LDataSetSoftSkills.Close);
      LDataSetSoftSkills.EntitySetName := 'Tblhbm_Softskills';
      await(LDataSetSoftSkills.Load);


      if Assigned(DataConnection) then
      begin
        LQuery             := TXDataWebDataSet.Create(nil);
        LQuery.Connection  := DataConnection;
        LQuery.AfterOpen   := WebDataSetAfterOpen;
      end;
      await(LQuery.Close);
      LQuery.EntitySetName  := 'tblWX_USER_DEFAULTS';
      LQuery.QueryString    := '$filter=(MUDF_USER_ID eq ' + DataModule.TokenInformation.UserID.toString + ') ' ;


      await(LQuery.Load);
    except
      wxBaseWriteLog.Write('Exception in TPrjClassHBMDataAccess.InitializeSession - Dataconnection retrieve data', slDebug);
      Result  := false;
    end;

    DataModule.isSpielleiter  := DataModule.TokenInformation.isSpielleiter;
    DataModule.isTeilnehmer   := DataModule.TokenInformation.isTeilnehmer;

    DataModule.HBMDefaultData.SeminarName           := DataModule.TokenInformation.SeminarName;
    DataModule.HBMDefaultData.AktuellePeriode       := DataModule.TokenInformation.PeriodId;
    DataModule.HBMDefaultData.LetztePeriode         := DataModule.TokenInformation.LastPeriodId;
    DataModule.HBMDefaultData.AktuellesUnternehmen  := DataModule.TokenInformation.AktEnterprise;
    DataModule.HBMDefaultData.LetztesUnternehmen    := DataModule.TokenInformation.LastEnterprise;
    DataModule.HBMDefaultData.MaxAnzUnternehmen     := DataModule.TokenInformation.MaxEnterprise;
    DataModule.HBMDefaultData.MinAnzUnternehmen     := DataModule.TokenInformation.MinEnterprise;
    if DataModule.TokenInformation.isCalculated then
      DataModule.HBMDefaultData.PeriodeGerechnet      := 1
    else
      DataModule.HBMDefaultData.PeriodeGerechnet      := 0;

    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Aktuell Simulation set to [' + DataModule.TokenInformation.SimulationID.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Simulation name set to [' + DataModule.HBMDefaultData.SeminarName + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Last period set to [' + DataModule.HBMDefaultData.LetztePeriode.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Actual period set to [' + DataModule.HBMDefaultData.AktuellePeriode.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Max enterprise set to [' + DataModule.HBMDefaultData.MaxAnzUnternehmen.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Min enterprise set to [' + DataModule.HBMDefaultData.MinAnzUnternehmen.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: actual enterprise set to [' + DataModule.HBMDefaultData.AktuellesUnternehmen.ToString + ']', slDebug);
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.InitializeSession: Logged in user name set to [' + DataModule.TokenInformation.UserName + ']', slDebug);

//    {$IFDEF APPISSPL}
//    PrjFormsMain.ToggleGUI;
//    {$ENDIF}

    result := true;
  except
    result := false;
    wxBaseWriteLog.Write('Exception in TPrjClassHBMDataAccess.InitializeSession', slDebug);
  end;
end;

function TPrjClassHBMDataAccess.ReloadSession(ADataConnection: TXDataWebConnection): Boolean;
var LIdx                : integer;
var LDataSetAbteilungen : TXDataWebDataSet;
var LDataSetStationen   : TXDataWebDataSet;
var LDataSetInstitue    : TXDataWebDataSet;
var LDataSetFaelle      : TXDataWebDataSet;
var LDataSetSoftSkills  : TXDataWebDataSet;
var LQuery              : TXDataWebDataSet;

begin
  result := false;
  try
//    Abteilungen := TTablePropertiesObjectList.Create;
//    drgFaelle   := TTablePropertiesObjectList.Create;
//    Institute   := TTablePropertiesObjectList.Create;
//    Stationen   := TTablePropertiesObjectList.Create;
//    SoftSkills  := TTablePropertiesObjectList.Create;
    if Assigned(ADataConnection) then
    begin
      try
        LDataSetAbteilungen             := TXDataWebDataSet.Create(nil);
        LDataSetAbteilungen.Connection  := ADataConnection;
        LDataSetAbteilungen.AfterOpen   := WebDataSetAfterOpen;
        await(LDataSetAbteilungen.Close);
        LDataSetAbteilungen.EntitySetName := 'Tblhbm_Abteilungen';
        await(LDataSetAbteilungen.Load);

        LDataSetStationen             := TXDataWebDataSet.Create(nil);
        LDataSetStationen.AfterOpen   := WebDataSetAfterOpen;
        LDataSetStationen.Connection  := ADataConnection;
        await(LDataSetStationen.Close);
        LDataSetStationen.EntitySetName := 'Tblhbm_Stationen';
        await(LDataSetStationen.Load);


        LDataSetInstitue             := TXDataWebDataSet.Create(nil);
        LDataSetInstitue.AfterOpen   := WebDataSetAfterOpen;
        LDataSetInstitue.Connection  := ADataConnection;
        await(LDataSetInstitue.Close);
        LDataSetInstitue.EntitySetName := 'Tblhbm_Institute';
        await(LDataSetInstitue.Load);


        LDataSetFaelle             := TXDataWebDataSet.Create(nil);
        LDataSetFaelle.AfterOpen   := WebDataSetAfterOpen;
        LDataSetFaelle.Connection  := ADataConnection;
        await(LDataSetFaelle.Close);
        LDataSetFaelle.EntitySetName := 'Tblhbm_Faelle';
        await(LDataSetFaelle.Load);

        LDataSetSoftSkills             := TXDataWebDataSet.Create(nil);
        LDataSetSoftSkills.AfterOpen   := WebDataSetAfterOpen;
        LDataSetSoftSkills.Connection  := ADataConnection;
        await(LDataSetSoftSkills.Close);
        LDataSetSoftSkills.EntitySetName := 'Tblhbm_Softskills';
        await(LDataSetSoftSkills.Load);

      except
        wxBaseWriteLog.Write('Exception in TPrjClassHBMDataAccess.ReloadSession - Dataconnection retrieve data', slDebug);
        Result  := false;
      end;
    end;
    result := true;
  except
    result := false;
    wxBaseWriteLog.Write('Exception in TPrjClassHBMDataAccess.ReloadSession', slDebug);
  end;
end;


function TPrjClassHBMDataAccess.RequestDBDaten(ADataSet: TXDataWebDataSet; AXDataConnection: TXDataWebConnection): Boolean;
begin
  Result := true;
  try
    if Assigned(AXDataConnection) and Assigned(ADataSet) then
    begin
      ADataSet.Connection := AXDataConnection;
      ADataSet.Load;
    end;
  except
    wxBaseWriteLog.Write('Exception in TPrjClassHBMDataAccess.RequestDBDaten', slDebug);
    result := false;
  end;
end;

function TPrjClassHBMDataAccess.RequestLockInformation: Boolean;
var LRequest      : TJSXMLHttpRequest;
var LResult       : TStringList;
var LIdx          : integer;
var LResultCheck  : Boolean;
begin
  Result := true;
  DataModule.HBMDefaultData.SystemIsLocked  := false;
  DataModule.HBMDefaultData.LockMessage     := '';
  try
//    WebRequest.URL := WebURL + '/SystemData/?SIM=SIM' + AktuelleSimulation.ToString + '&USR=' + DataModule.TokenInformation.SimulationID + '&DATA=LOCKINFO';
//    WebRequest.Headers.Add('AktUser=' + TokenInformation.SimulationID );
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestLockInformation : Der WebRequest ' + WebRequest.URL + ' wird gesendet', slDebug);
    LRequest := await(TJSXMLHttpRequest, WebRequest.Perform());
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestLockInformation : Answer received: ' + LRequest.ResponseText, slDebug);
    LResult := TStringList.Create;
    try
      LResult.CommaText   := LRequest.ResponseText;
      LResultCheck        := false;
      for LIdx := 0 to lResult.Count - 1 do
      begin
        LResultCheck := (LResult.Strings[LIdx] = 'LockIni') or (LResult.Strings[LIdx] = 'LockModerator');
        if LResult.Strings[LIdx] = 'LockIni' then
        begin
          DataModule.HBMDefaultData.LockMessage := cLockIniMessage;
          break;
        end else
        begin
          DataModule.HBMDefaultData.LockMessage := cLockModeratorMessage;
        end;
      end;
      if LResultCheck then
      begin
        DataModule.HBMDefaultData.SystemIsLocked  := true;
        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestLockInformation : Eintag gemacht : ' + LResult.CommaText, slDebug);
      end else
      begin
        DataModule.HBMDefaultData.LockMessage     := '';
        DataModule.HBMDefaultData.SystemIsLocked  := false;
        wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestLockInformation : Eintag gelöscht ', slDebug);
      end;
    finally
      FreeAndNil(LResult);
    end;
  except
    wxBaseWriteLog.Write('TPrjClassHBMDataAccess.RequestLockInformation: Es ist ein Fehler aufgetreten', slError);
    DataModule.HBMDefaultData.LockMessage     := '';
    DataModule.HBMDefaultData.SystemIsLocked  := false;
    Result := false;
  end;
end;

procedure TPrjClassHBMDataAccess.WebRequestAbort(Sender: TObject);
begin
  wxBaseWriteLog.Write('HBMWebData::WebHttpRequest1 Abort: HTTP Request aborted', slDebug);
end;

procedure TPrjClassHBMDataAccess.WebRequestError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var
    Handled: Boolean);
begin
  wxBaseWriteLog.Write('HBMWebData::WebHttpRequest1 Error: HTTP Request failed', slError);
end;

procedure TPrjClassHBMDataAccess.WebRequestTimeout(Sender: TObject);
begin
  wxBaseWriteLog.write('HBMWebData::WebHttpRequest1 Timeout: Timeout occured', slDebug);
end;

procedure TPrjClassHBMDataAccess.WebTimerTimer(Sender: TObject);
begin
  await(Self.RequestLockInformation);
end;

function TPrjClassHBMDataAccess.XDataWebClient(AXDataConnection: TXDataWebConnection): TXDataWebClient;
begin
  if Assigned(AXDataConnection) then
  begin
    Result := TXDataWebClient.Create(nil);
    Result.Connection := AXDataConnection;
  end;
end;


end.
